import { useEffect, useState } from 'react';

/**
 * El "look" de la plataforma: clásico o Apple.
 *
 * Es un eje APARTE del claro/oscuro, que ya vivía en `data-theme`. Son dos
 * preguntas independientes y mezclarlas obligaría a cuatro valores en un
 * solo atributo; así el interruptor de oscuro sigue intacto.
 *
 * Va en localStorage y ahí corresponde: es una preferencia de vista de esta
 * persona en este navegador, no un dato de la empresa. Que a alguien le
 * guste el look nuevo no obliga a su encargado a verlo igual. (La ubicación
 * del clima es el caso contrario y por eso ésa sí vive en el servidor.)
 *
 * El valor se aplica también ANTES de que React monte —ver `aplicarLook`, que
 * main.tsx llama al arrancar— porque si no, el primer cuadro se dibuja con
 * el look clásico y se ve un parpadeo al cambiar.
 */
export type Look = 'clasico' | 'apple';

const LLAVE = 'app_look';

export function lookGuardado(): Look {
  try {
    return localStorage.getItem(LLAVE) === 'apple' ? 'apple' : 'clasico';
  } catch {
    return 'clasico';
  }
}

/** Escribe el atributo en el documento. Sin React, para poder usarlo al arrancar. */
export function aplicarLook(look: Look = lookGuardado()): void {
  const raiz = document.documentElement;
  if (look === 'apple') raiz.setAttribute('data-look', 'apple');
  else raiz.removeAttribute('data-look');
}

export function useLook() {
  const [look, setLook] = useState<Look>(lookGuardado);

  useEffect(() => {
    aplicarLook(look);
    try { localStorage.setItem(LLAVE, look); } catch { /* modo privado */ }
  }, [look]);

  return {
    look,
    esApple: look === 'apple',
    alternar: () => setLook(l => (l === 'apple' ? 'clasico' : 'apple')),
  };
}
